const CARD_SELECTOR = 'collection-component product-card';

function replaceVisibleButtonLabel(button, label) {
  if (!button || button.disabled) return;
  for (const node of button.childNodes) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
      node.textContent = ` ${label} `;
      button.setAttribute('aria-label', label);
      return;
    }
  }
}

function enhanceCard(card) {
  if (!(card instanceof HTMLElement) || card.dataset.premiumGridEnhanced === 'true') return;
  card.dataset.premiumGridEnhanced = 'true';
  card.classList.add('premium-product-card');

  const content = card.querySelector('.product-card__content');
  const quickAdd = card.querySelector('quick-add-component');
  if (content && quickAdd) {
    const wrapper = document.createElement('div');
    wrapper.className = 'premium-product-card__quick-add';
    content.appendChild(wrapper);
    wrapper.appendChild(quickAdd);

    replaceVisibleButtonLabel(quickAdd.querySelector('.quick-add__button--add'), 'Add to Cart');
    replaceVisibleButtonLabel(quickAdd.querySelector('.quick-add__button--choose'), 'Choose Options');
  }

  const size = card.querySelector('.premium-card__size');
  const sizeContainer = size?.parentElement;
  if (sizeContainer && !size?.textContent.trim()) sizeContainer.classList.add('premium-card__size-container--empty');
}

function enhanceAll(root = document) {
  root.querySelectorAll(CARD_SELECTOR).forEach(enhanceCard);
}

enhanceAll();

document.addEventListener('DOMContentLoaded', () => enhanceAll(), { once: true });

const collectionRoot = document.querySelector('collection-component');
if (collectionRoot) {
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(CARD_SELECTOR)) enhanceCard(node);
        enhanceAll(node);
      }
    }
  }).observe(collectionRoot, { childList: true, subtree: true });
}
